// components/Pages/RM/Inventory/LocationModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const LocationModal = ({ show, onHide, inventoryItem, onSave }) => {
    const [formData, setFormData] = useState({
        warehouse: '',
        shelf: '',
        bin: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (inventoryItem) {
            setFormData({
                warehouse: inventoryItem.location?.warehouse || '',
                shelf: inventoryItem.location?.shelf || '',
                bin: inventoryItem.location?.bin || ''
            });
        }
    }, [inventoryItem]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.warehouse.trim()) {
            newErrors.warehouse = 'Warehouse is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const data = {
                warehouse: formData.warehouse.trim(),
                shelf: formData.shelf.trim(),
                bin: formData.bin.trim()
            };
            onSave(data);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Update Location - {inventoryItem?.rawMaterial?.name}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Alert variant="info">
                        <strong>Current Location:</strong><br />
                        Warehouse: {inventoryItem?.location?.warehouse || 'Not set'}<br />
                        Shelf: {inventoryItem?.location?.shelf || 'Not set'}<br />
                        Bin: {inventoryItem?.location?.bin || 'Not set'}
                    </Alert>

                    <Form.Group className="mb-3">
                        <Form.Label>Warehouse *</Form.Label>
                        <Form.Control
                            type="text"
                            name="warehouse"
                            value={formData.warehouse}
                            onChange={handleChange}
                            placeholder="Enter warehouse name"
                            required
                            isInvalid={!!errors.warehouse}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.warehouse}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            Primary warehouse location
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Shelf</Form.Label>
                        <Form.Control
                            type="text"
                            name="shelf"
                            value={formData.shelf}
                            onChange={handleChange}
                            placeholder="Enter shelf number"
                        />
                        <Form.Text className="text-muted">
                            Specific shelf location within the warehouse
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Bin</Form.Label>
                        <Form.Control
                            type="text"
                            name="bin"
                            value={formData.bin}
                            onChange={handleChange}
                            placeholder="Enter bin number"
                        />
                        <Form.Text className="text-muted">
                            Specific bin location on the shelf
                        </Form.Text>
                    </Form.Group>

                    <Alert variant="info" className="mt-3">
                        <strong>Tip:</strong> Use a consistent naming convention for easier inventory management.
                        <br />
                        Example: Warehouse A - Shelf 12 - Bin 34
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary">
                        Update Location
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default LocationModal;